import React from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/whatsapp";

export default function WhatsAppFloat() {
  return (
    <a
      href={waLink("Hi PrintMyTees, I have a question.")}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-40 bg-[#25D366] text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:bg-[#1EBE5D] transition-colors"
      data-testid="whatsapp-float"
    >
      <MessageCircle size={26} />
    </a>
  );
}
